import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'shared/error/error-fallback';

export function ProvideErrorBoundary({ children }: PropsWithChildren<{}>) {
    return <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>;
}
